import { call, fork, put, take } from 'redux-saga/effects';
import { loadReferralSummary, setReferralSummary, referralSummaryFailed } from './reducer';
import apiService from '../../api/apiServices/apiService';
import { toast } from 'react-toastify';

function* watchLoadReferralSummary() {
  while (true) {
    yield take(loadReferralSummary.type);

    const { success, reject } = yield call([apiService, apiService.getReferralSummary]);

    if (success) {
      yield put(setReferralSummary(success.payload));
    }
    if (reject) {
      yield put(referralSummaryFailed());
      toast.error(reject.payload.message);
    }
  }
}

export default function* referralSaga() {
  yield fork(watchLoadReferralSummary);
}
